import Heading from 'components/common/Heading';
import Subheading from 'components/common/Subheading';
import useQuery from 'hooks/useQuery';
import HCWaveBorder from 'images/HCWaveBorder.svg';
import HomeChefKrogerLogo from 'images/logo/homeChefKroger.png';
import HCMeatloaf from 'images/signUpFunnel/intro-bacon-cheddarjack-meatloaf.png';
import HCPorkNoodles from 'images/signUpFunnel/korean-pork-noodles.png';

const HomeChefHeader = ({ isFamilyLead }) => {
  const { isQueryParamTrue: hasKrogerParam } = useQuery('kroger', 'true');

  return (
    <>
      {!hasKrogerParam && (
        <div className="relative">
          <div className="bg-green-110 py-8 text-center">
            <div className="mx-auto max-w-xl bp1:max-w-3xl">
              <Heading className="h2 text-white-100">
                <span className="block bp1:hidden">
                  #1 in
                  <br />
                  Convenience*
                </span>
                <span className="hidden bp1:inline">#1 in Convenience*</span>
              </Heading>
              <Subheading className="mx-auto max-w-sm pt-4 text-white-100 bp1:max-w-3xl bp1:pt-2">
                Home Chef has the most convenient meal options of leading meal kits.
              </Subheading>
            </div>
          </div>

          <div
            style={{ backgroundImage: `url(${HCWaveBorder})` }}
            className="-mt-px mb-8 h-4 bg-cover bg-repeat-round p-0 bp1:h-12"
          />
          <div>
            <img
              className="absolute -right-10 -top-8 w-44 bp1:inset-1/2 bp1:top-16 bp1:w-72 bp1:translate-x-72"
              src={HCPorkNoodles}
              alt="Pork Noodles"
            />
            <img
              className="absolute -left-10 -top-8 w-44 bp1:inset-1/2 bp1:top-16 bp1:w-72 bp1:-translate-x-[35rem]"
              src={HCMeatloaf}
              alt="Cheddar Meatloaf"
            />
          </div>
        </div>
      )}

      {hasKrogerParam && (
        <div
          className={`mb-4 flex justify-center pt-8 ${!(isFamilyLead && hasKrogerParam) ? 'bp1:mb-6' : 'bp1:-mb-10'}`}
        >
          <img src={HomeChefKrogerLogo} alt="Home Chef Kroger" className="w-full max-w-[27rem]" />
        </div>
      )}
      {/* prettier-ignore */}
      <Heading className="mx-auto mb-2 max-w-xl text-center" >
        {isFamilyLead ? '' : 'Let\'s get to know you a bit!'}
      </Heading>
    </>
  );
};

HomeChefHeader.propTypes = {
  isFamilyLead: PropTypes.bool.isRequired,
};

export default HomeChefHeader;
